module.exports = __webpack_public_path__ + "static/media/back6.223fb467.jpg";